module.exports = __webpack_public_path__ + "static/media/rightArrowIcon.71e4738d.svg";